import { Box } from '@auviknetworks/iceberg-ui';
import { Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import {
    DateFormatCell,
    NumberCell
} from 'application/Shared/Components/Cells';
import {
    Header,
    ManagedTableV2ContextProvider,
    ManagedTableV2UI
} from 'application/Shared/Components/Table';
import { Tenant } from 'application/Shared/types/tenant';
import React, { useMemo } from 'react';

import { CustomCard } from './Shared/CustomCard';

export type StatType = 'billingUsers' | 'totalUsers';
interface TenantStat {
    id: string;
    day: string;
    value: number;
}

const columns = [
    {
        accessorKey: 'day',
        cell: (
            props: CellContext<TenantStat, string | number | Date | null>
        ) => <DateFormatCell {...props} noTimeString />,
        enableColumnFilter: false,
        header: Header,
        id: 'day',
        name: 'Common.day',
        size: 160
    },
    {
        accessorKey: 'value',
        cell: NumberCell,
        enableColumnFilter: false,
        header: Header,
        id: 'value',
        name: 'Common.value',
        size: 160
    }
];

export const TenantStats = ({
    tenant,
    statType,
    title,
    description
}: {
    tenant: Tenant;
    statType: StatType;
    title: string;
    description?: React.ReactNode;
}) => {
    const baseParameters = useMemo(
        () => ({
            // We don't want to get the 'data' field for now. billingUsers entries can be quite large.
            fields: '[day,value]',
            key: statType,
            order: 'DESC',
            platformTenantId: tenant.id,
            sort: 'day'
        }),
        [tenant.id, statType]
    );

    return (
        <ManagedTableV2ContextProvider
            apiSize={30}
            columns={columns}
            rowsApi="/tenantStat"
            baseParameters={baseParameters}
            getRowId="id"
            ignoreSearchParams
            mode="client"
            rowsApiPreload
            rowsPerPage={50}
            sortKey="day"
            sortDirection="DESC"
            tableName="globalAdminStatsTable"
        >
            <CustomCard noPadding>
                <Box padding="16px">
                    <Typography variant="h6" marginBottom="16px">
                        {title}
                    </Typography>

                    {description}
                </Box>
                <ManagedTableV2UI renderFooter />
            </CustomCard>
        </ManagedTableV2ContextProvider>
    );
};
